export default function RoleTable() {
  const data = [
    {
      id: 1,
      usecase: "New Admin",
      email: "suchitagome@gmail.com",
      name: "Suchita zdz demo",
    },
  ];

  return (
    <div className="ad-table-scroll">
      <table className="ad-table">

        <thead>
          <tr>
            <th>Sr.No</th>
            <th>UseCase Name</th>
            <th>Email</th>
            <th>FullName</th>
            <th>SQL Configured</th>
            <th>File Configured</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row) => (
            <tr key={row.id} className="ad-table-row">
              <td>{row.id}</td>
              <td>{row.usecase}</td>
              <td>{row.email}</td>
              <td>{row.name}</td>

              <td>
                <span className="ad-badge ad-badge-active">Yes</span>
              </td>

              <td>
                <span className="ad-badge ad-badge-active">Yes</span>
              </td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
}